<template>
  <TextField
    id="mealplan-name"
    :name="name"
    :label="t('sites.singleSite.financialConfig.mealPlans.form.planName')"
    :placeholder="t('sites.singleSite.financialConfig.mealPlans.form.planNamePlaceholder')"
    required
    :disabled="disabled"
  />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

defineProps({
  name: {
    type: String,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});
</script>
